import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { ReportType, RootState, RECEIVE_POSTS, REQUEST_POSTS, UPDATE_UNTIL, REQUEST_FAILED } from "./types"

import { ajax } from '../../utils/ajax'
import { REPORT_LIMIT } from '../../utils/config'
import { formatDate, dayBefore } from '../../utils/date'

interface paramType {
  limit: number,
  until?: string
}
interface ResponseType {
  end: string,
  gender: number,
  reports: ReportType[],
  since: string,
  thumbnail_url: string,
  token: string
}
/**请求日报 */
export const fetchPosts = () => async (dispatch: ThunkDispatch<RootState, void, AnyAction>, getState: () => RootState) => {
  await dispatch(requestPosts())
  const { until } = getState().dailyReport
  let url: string = `/v2/api/daily_report`
  let params: paramType = {
    limit: REPORT_LIMIT,
  }
  if (until) {
    params.until = until
  }
  const res = await ajax.request<any, ResponseType>({ url, params })
  await dispatch(updateReport(res))
}
/**处理请求数据 */
const updateReport = (res: ResponseType) => async (dispatch: ThunkDispatch<RootState, void, AnyAction>, getState: () => RootState) => {
  const { reports } = getState().dailyReport
  if (res) {
    if (!res.reports || res.reports.length === 0) {
      // 如果请求的limit内没有日报，那么以返回的日报最后更新的日期为 until 重新请求
      await dispatch(updateUntil(res.end))
      await dispatch(fetchPosts())
    } else {
      let allReports: ReportType[] = res.reports.concat(reports ? reports : [])
      let until = formatDate(dayBefore(allReports[0].report_date))
      const allLoaded = (allReports[0].report_date === res.since)
      const lenLastFetch = res.reports.length
      const isFirstFetch = reports.length === 0 && lenLastFetch > 0
      await dispatch(receivePosts({
        reports: allReports,
        since: res.since,
        until,
        allLoaded,
        lenLastFetch,
        isFirstFetch,
      }))
    }
  } else {
    await dispatch(requestFailed(false))
  }

}

/** 拿到请求结果 */
export function receivePosts(param: Pick<RECEIVE_POSTS, Exclude<keyof RECEIVE_POSTS, 'type'>>): RECEIVE_POSTS {
  return {
    type: 'RECEIVE_POSTS',
    ...param
  }
}

/** 更新请求中的状态*/
export const requestPosts: () => REQUEST_POSTS = () => ({
  type: 'REQUEST_POSTS',
})

/** 更新until值 */
export function updateUntil(until: string): UPDATE_UNTIL {
  return {
    type: 'UPDATE_UNTIL',
    until: until
  }
}

/**请求失败*/
export function requestFailed(status: boolean): REQUEST_FAILED {
  return {
    type: 'REQUEST_FAILED',
    status: status
  }
}

